import React from 'react';
import {
	MenuListItem,
	MenuSection,
	MenuSectionHeading,
	MenuList,
} from '@atlaskit/navigation-system';

import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

type RecentItemsType = {
	list: Array<React.JSX.Element>;
	hasItems: boolean;
};

export function RenderRecentBoardsSection({ recentItems }: { recentItems: RecentItemsType }) {
	const { formatMessage } = useIntl();

	return (
		recentItems.hasItems && (
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-jsw-project-menu.ui.jsw-expandable-project.async-content.jsw-boards.recent-section">
				<MenuSection>
					<MenuSectionHeading>{formatMessage(messages.recent)}</MenuSectionHeading>
					<MenuList>{recentItems.list}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
}
